import classNames from 'classnames/bind';
import { MouseEvent, ReactElement } from 'react';
import { Button, ButtonMode, DataView } from '@creditsights/styleguide-web';
import { isNil } from 'lodash';
import { Link } from 'react-router-dom';
import styles from './ArticleIncludedContent.module.scss';
import { ArticleTableRow } from '../../../models/ArticleTableRow';
import { viewConfig, printViewConfig, getKey } from './ArticleIncludedContent.logic';
import { ArticleIncludedContent as IncludedContent } from '../../../models';
import { ROUTES } from '../../../Base.constants';

const cx = classNames.bind(styles);

interface ArticleIncludedContentProps {
  includedContent: IncludedContent[] | undefined;
  isCompact?: boolean;
  noSpacing?: boolean;
  noShadow?: boolean;
  onArticleClick?: (article: ArticleTableRow, event: MouseEvent<HTMLElement>) => void;
  isPreviewable?: boolean;
  print?: boolean;
  previewedArticleId?: number | null;
  isSectorReview?: boolean;
  isArticlePreview?: boolean;
}

const ArticleIncludedContent = ({
  includedContent,
  onArticleClick,
  isPreviewable,
  print,
  isCompact,
  noSpacing,
  noShadow,
  previewedArticleId,
  isSectorReview,
  isArticlePreview,
}: ArticleIncludedContentProps): ReactElement | null => {
  if (!includedContent?.length) {
    return null;
  }

  const renderSectorReviewContent = () => (
    <div
      className={cx({
        'two-column-view': !isArticlePreview,
      })}
    >
      {includedContent.map((item) => (
        <div key={item.id} className={cx('sector-review-item')} data-testid="sector-review-item">
          {onArticleClick ? (
            <Button mode={ButtonMode.PLAIN} onClick={(e) => onArticleClick(item, e)}>
              {item.content.title}
            </Button>
          ) : (
            <Link to={ROUTES.article(item.id)}>{item.content.title}</Link>
          )}
        </div>
      ))}
    </div>
  );

  const articleBodyClass = cx('body', {
    compact: isCompact,
    'no-spacing': noSpacing || print,
    'no-shadow': noShadow,
  });
  return (
    <div className={articleBodyClass} data-testid="article-included-content">
      {isSectorReview ? (
        renderSectorReviewContent()
      ) : (
        <DataView
          data={includedContent}
          config={print ? printViewConfig : viewConfig(onArticleClick, isPreviewable)}
          getKey={getKey}
          expanded
          activeKeys={!isNil(previewedArticleId) ? Array.of(previewedArticleId) : undefined}
        />
      )}
    </div>
  );
};

export default ArticleIncludedContent;
